RCA.client.Gdpr = (function () {
    /* ----- Init ----------------------------------------------------------------------------------------------------- */
    function Init() {
        render();
        $(document).on("click", "#gdpr .accept-gdpr", acceptGdpr);
        $(document).on("click", "#gdpr .doc-link", openGdpr);

        if (RCA.shared.AppData.modulsettings.showgdpr && (RCA.shared.AppData.profile.gdpr == undefined || !RCA.shared.AppData.profile.gdpr)) {
            RCA.client.Layout.show("gdpr", true);
        }
    }

    /* ----- Init ----------------------------------------------------------------------------------------------------- */
    function render() {
        $('#gdpr').find('.data-text').html(RCA.client.nl2brStrict(RCA.shared.AppData.gdpr.gdpr[RCA.shared.localState.lang]));

        var label_text = RCA.shared.AppData.gdpr.checkbox_text[RCA.shared.localState.lang];
        if (RCA.shared.AppData.gdpr.checkbox_text[RCA.shared.localState.lang] != undefined) {
            if (RCA.shared.AppData.gdpr.linked_doc) {
                label_text = label_text.replace("[link]", '<a href="javascript:void(0);" class="color-primary doc-link" data-target="' + RCA.shared.AppData.gdpr.linked_doc + '">');
                label_text = label_text.replace("[/link]", '</a>');
            } else {
                label_text = label_text.replace("[link]", '');
                label_text = label_text.replace("[/link]", '');
            }
        }

        var add_label_text = RCA.shared.AppData.gdpr.add_checkbox_text[RCA.shared.localState.lang];

        $('#gdpr').find('.chk-label').html(label_text);
        $('#gdpr').find('.chk-label-add').html(add_label_text);

        $('#gdpr').find('.chk-label-add').hide();

        if ($.inArray(RCA.shared.AppData.profile.group, RCA.shared.AppData.gdpr.group) > -1) {
            $('#gdpr').find('.chk-label-add').show();
        }

        $('#gdpr').find('.accept-gdpr').html(RCA.shared.AppData.gdpr.button_text[RCA.shared.localState.lang]);
        $('#gdpr').find('header .close-main').hide();
        $('#gdpr').find('header .hamburger').hide();
        $('#gdpr').find('header .data-icon').hide();
        $('#gdpr').find('header').css({
            "pointer-events": "none"
        });

        $('#gdpr').find('header .data-label').html(RCA.shared.Language.getItem("gdpr-title"));
    }

    /* ----- Init ----------------------------------------------------------------------------------------------------- */
    function update() {
        $.post('api/', {
            do: 'getGdpr'
        }, function (data) {
            RCA.shared.AppData.gdpr = data;
            RCA.client.Gdpr.render();
            data = null;
        });
    }

    function openGdpr(e) {
        var id = $(this).attr("data-target");
        var el = RCA.shared.AppData.docs.find(function(item) {
            return item.id == id;
        });

        $('#gdpr-docs').find('header .hamburger').hide();

        $('#gdpr-docs').find('header .header-primary').css({
            "pointer-events": "none"
        });

        $('#gdpr-docs .data-label').text(el.title[RCA.shared.localState.lang]);
        $('#gdpr-docs embed').attr('src', './pdfjs/web/viewer.html?file=../../upload/docs/' + el.files[RCA.shared.localState.lang].filename);
        RCA.client.Layout.show("gdpr-docs");

        var index = RCA.shared.localState.layout.indexOf("gdpr-docs");
        if (index > -1) {
            RCA.shared.localState.layout.splice(index, 1);
        }
    }

    function acceptGdpr() {

        if (!$("#gdpr .accept-gdpr-chk").prop("checked")) {
            $('#modal').css({
                "z-index": 10000000
            });
            RCA.client.Modal.alert(RCA.shared.AppData.gdpr.alert_text[RCA.shared.localState.lang], function() {
                $('#modal').css({
                    "z-index": ""
                });
            });
            return;
        }

        if (RCA.shared.AppData.gdpr.add_chk_mandatory && !$("#gdpr .accept-gdpr-chk-add").prop("checked") && $.inArray(RCA.shared.AppData.profile.group, RCA.shared.AppData.gdpr.group) > -1) {
            $('#modal').css({
                "z-index": 10000000
            });
            RCA.client.Modal.alert(RCA.shared.AppData.gdpr.add_alert_text[RCA.shared.localState.lang], function() {
                $('#modal').css({
                    "z-index": ""
                });
            });
            return;
        }

        $.post('api/', {
            do: 'acceptGdpr',
            addChk: $("#gdpr .accept-gdpr-chk-add").prop("checked")
        }, function (data) {
            RCA.shared.AppData.profile = data;
            RCA.client.Layout.hide("gdpr");
            RCA.client.Navigation.setAllowCloseMenu();
        });

    }

    /* ----- Public API ----------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        render: render,
        update: update
    }
})();
